import { render, staticRenderFns } from "./claimOrder.vue?vue&type=template&id=672d5ba8&"
import script from "./claimOrder.vue?vue&type=script&lang=js&"
export * from "./claimOrder.vue?vue&type=script&lang=js&"
import style0 from "./claimOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports